import React, { useRef } from "react";
import SEO from "../components/SEO/SEO";
import { useParams, useNavigate } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import Canvas from '../components/canvas/Canvas';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useSigilContext } from '../context/sigilContext';

// Asume que tienes un componente DrawBox y una función para obtener el sigilo por ID

const ViewSigile = () => {
  useParams();
  const navigate = useNavigate();
  const stageRefs = useRef([]);
  const {
    criptoText,
    savedName,
  } = useSigilContext();


  return (
    <>
      <SEO
        title={`${savedName || 'Sigilo'} | Magia del Caos`}
        description="Visualiza tu sigilo creado. Utiliza la energía del caos para manifestar tu intención."
        name="Magia del Caos"
        type="article"
      />
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        marginX: '16px',
        minHeight: '100vh',
        height: '100%',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: '80px',
        boxSizing: 'border-box'
      }}>
        <h1>{criptoText.replace(/\s+/g, '').toUpperCase().replace()}</h1>

        <Box
          sx={{
            //border: '1px solid white',
            borderRadius: '18px',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: '300px',
            maxHeight: '70vh',
            overflow: 'hidden',
            backgroundColor: '#2C2C2C',
            width: '100%' // Asegura que ocupe el ancho disponible
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              width: '100%',
              height: '100%'
            }}
          >
            <Canvas stageRefs={stageRefs} readOnly={true} />
          </Box>
        </Box>

        <Box sx={{
          position: 'fixed',
          bottom: '20px',
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <IconButton
            sx={{
              backgroundColor: 'white',
              width: '54px',
              height: '54px',
              boxShadow: 3,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)'
              }
            }}
            onClick={() => navigate(-1)}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </Box>

      </Box >
    </>
  );
};

export default ViewSigile;